<!--
 * @Author: FengXiao
 * @Date: 2020-07-01 22:24:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-13 23:55:04
-->
<template>
  <div class="top_bar-base">
    <div class="top_bar-content">
      <transition name="fade">
        <div class="logo-bl" :class="{ hide: !unfold }">
          <img class="logo-img" src="../assets/imgs/yixi-logo.jpg" alt="YIXI LOGO" srcset="" />
        </div>
      </transition>
      <div class="top_bar-bottom-bl">
        <div class="text-logo" :class="{ show: !unfold }">
          <img class="text-logo-img" src="../assets/imgs/text-logo.png" alt="" />
        </div>
        <!-- <div class="company-logo" :class="{ show: !unfold }">
          <img class="text-logo-img" src="../assets/imgs/company_logo.png" alt="" />
        </div> -->
        <transition name="fade">
          <div class="tabs-bl">
            <el-tabs v-model="activeTab" @tab-click="gotoPage">
              <el-tab-pane :label="tab.label" :name="tab.path" v-for="tab in tabs" :key="tab.path"></el-tab-pane>
            </el-tabs>
            <div class="top_bar-actions-bl">
              <div class="search-icon btn" @click="showSearchRes = true" v-show="!showSearchRes">
                <i class="iconfont iconsearch"></i>
              </div>
              <div class="close-btn btn" v-show="showSearchRes" @click="showSearchRes = false">
                <i class="iconfont iconclose"></i>
              </div>
              <div class="user-icon btn" @click="onClickUserIcon">
                <i class="iconfont iconuser" v-show="!userAvatar"></i>
                <img :src="userAvatar" class="user_avatar" v-show="userAvatar" />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div
      class="search_res-wrap"
      :class="{ show: showSearchRes }"
      :style="{ top: `${searchTop}px`, height: showSearchRes ? `calc(100vh - ${searchTop}px)` : 0 }"
    >
      <div class="search-bl">
        <div class="search_input">
          <input
            type="text"
            v-model="searchKeywords"
            placeholder="搜索"
            placeholder-style="color:#cccccc;"
			@compositionstart="flag = false" 
			@compositionend="flag = true"
            ref="searchInput"
            @focus="searchIptFocus = true"
            @blur="searchIptFocus = false"
          />
          <i class="iconfont iconsearch" :class="{ active: searchIptFocus }"></i>
        </div>
        <div class="search_results-bl" v-show="searchResults.length && searchKeywords">
          <div v-for="res in searchResults" :key="res.key">
            <div class="search_results-title">{{ res.title }}</div>
            <div class="search_results">
              <div class="search-item" v-for="item in res.list" :key="item.title" @click="gotoDetail(item, res.key)">
                {{ item.title || item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="search_historys-bl" v-show="!searchKeywords">
          <div class="history-item" v-for="item in searchHistorys" :key="item" @click="searchKeywords = item">
            {{ item }}
          </div>
        </div>
        <div class="empty-bl" v-show="!searchResults.length && searchKeywords">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import requestApi from '@/service';
import { mapState } from 'vuex';
// import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
const UNFOLD_SCROLL_TOP = 80;
export default {
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    // [CollapseTransition.name]: CollapseTransition,
  },
  data() {
    return {
      searchResults: [],
      activeTab: 'Home',
      tabs: [
        { label: '首页', path: 'home' },
        { label: '演讲', path: 'speech' },
        { label: '现场', path: 'activity' },
        { label: '万象', path: 'wanxiang' },
        { label: '枝桠', path: 'zhiya' },
        { label: '记录', path: 'record' },
        // { label: '资讯', path: 'information' },
      ],
      unfold: true,
      searchKeywords: '', // 搜索结果
      showSearchRes: false, // 显示搜索
      searchHistorys: [], // 搜索历史
      searchIptFocus: true,
    };
  },
  created() {
    this._addEvent();
  },
  beforeDestroy() {
    this._removeEvent();
  },
  computed: {
    userAvatar() {
      return (this.$store.state.user && this.$store.state.user.avatar) || null;
    },
    searchTop() {
      return this.unfold ? 178 : 88;
    },
	...mapState(['vipInfo']),
  },
  watch: {
    showSearchRes(val) {
      this.$store.commit('showSearch', val);
      if (val && window.scrollY > UNFOLD_SCROLL_TOP) {
        this.saveScrollTop = window.scrollY;
      } else if (this.saveScrollTop) {
        this.$nextTick(() => {
          window.scrollTo(0, this.saveScrollTop);
          this.saveScrollTop = null;
        });
      }
      if (val) {
        this.searchHistorys = this.getSearchHistorys();
        setTimeout(() => {
          this.$refs.searchInput.focus();
        }, 100);
      }
    },
    searchKeywords() {
      if (this.searchKeywords) {
        this.search();
      } else {
        this.searchResults = [];
        this.searchHistorys = this.getSearchHistorys();
      }
    },
    $route(to) {
      let matching = false;
      for (const tab of this.tabs) {
        if (to.path.includes(`/${tab.path}`)) {
          this.activeTab = tab.path;
          matching = true;
          break;
        }
      }
      if (!matching) {
        this.activeTab = '';
      }
    },
  },
  methods: {
    _addEvent() {
      window.addEventListener('scroll', this._scrollEvent);
    },
    _removeEvent() {
      window.removeEventListener('scroll', this._scrollEvent);
    },
    _scrollEvent() {
      this.unfold = !this.showSearchRes && window.scrollY < UNFOLD_SCROLL_TOP;
    },
    getSearchHistorys() {
      return localStorage.searchHistorys ? localStorage.searchHistorys.split(',') : [];
    },
    /**
     * @description: 更新本地搜索缓存
     * @param {type}
     * @return {type}
     */
    updateLocalHistory() {
      if (this.searchKeywords) {
        const arr = this.searchHistorys;
        if (arr.includes(this.searchKeywords)) {
          const index = arr.indexOf(this.searchKeywords);
          arr.splice(index, 1);
        }
        arr.unshift(this.searchKeywords);
        localStorage.searchHistorys = arr.join(',');
      }
    },
    /**
     * @description: 跳转至对应Tab Page
     * @param {type} @tab{Object}: tab对象
     * @return:
     */
    gotoPage() {
      const path = `/${this.activeTab}`;
      if (this.showSearchRes) this.showSearchRes = false;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    /**
     * @description: 搜索
     * @param {type}
     * @return:
     */
    search() {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => {
        this.searchTimer = null;
        if (this.searchKeywords) {
			requestApi('/v3/api/h5/search/new/v2/',{
				keyword:this.searchKeywords,
				search_type:1,
				action:1,
			}).then(res => {
				const speecharr = [];
				const wanxiangarr = [];
				const zhiyaarr = [];
				const recodearr = [];
				const huaxuarr = [];
				 
				res.items.forEach(item => {
					if(item.video_type == 0) {
						speecharr.push(item)
					}
					if(item.video_type == 7 || item.video_type == 17) {
						wanxiangarr.push(item)
					}
					if(item.video_type == 2 || item.video_type == 12) {
						zhiyaarr.push(item)
					}
					if(item.video_type == 4) {
						recodearr.push(item)
					}
					if(item.video_type == 10) {
						huaxuarr.push(item)
					}
				})
				const list = [
					{	
						key:'speech',
						title:'演讲',
						list:speecharr,
					},
					{
						key:'wanxiang',
						title:'万象',
						list:wanxiangarr,
					},
					{
						key:'zhiya',
						title:'枝桠',
						list:zhiyaarr,
					},
					{
						key:'record',
						title:'记录',
						list:recodearr,
					},
					{
						key:'huaxu',
						title:'花絮',
						list:huaxuarr,
					},
				]
				this.searchResults = [];
				list.forEach(item => {
					if(item.list.length > 0) {
						this.searchResults.push(item)
					}
				})
				this.updateLocalHistory();
			})
        } else {
          this.searchResults = [];
        }
      }, 500);
    },
    /**
     * @description: 跳转详情
     * @param {type}
     * @return:
     */
    gotoDetail(data, type) {
		console.log(data,type)
		// return
      switch (type) {
        case 'record':
        case 'speech':
          this.$router.push({
            path: `/${type}/detail`,
            query: {
              id: data.id,
            },
          });
          break;
        case 'zhiya':
          this.$router.push({
            path: `/${type}/detail`,
            query: {
              id: data.zhiya_id || data.id,
              episodeId: data.video_id || data.id,
            },
          });
          break;
		  case 'huaxu':
			this.$router.push({
			  path: `/speech/detail`,
			  query: {
				id: data.id,
				videotype: 10,
			  },
			});
			break;
			case 'wanxiang':
			this.checkwanxiang(data)
			 
			  break;
        default:
          break;
      }
      this.showSearchRes = false;
    },
    /**
     * @description: 点击头像
     * @param {type}
     * @return {type}
     */
    onClickUserIcon() {
      if (this.checkLogin()) {
        this.$router.push('/userCenter');
      }
    },
	checkwanxiang(data) {
		requestApi('/v3/api/h5/wanxiang_check/',{
			video_id:data.video_id || data.id,
			video_type:7,
		}).then(res => {
			 this.$router.push({
				path: `/wanxiang/detail`,
				query: {
				  id: data.wanxiang_id || data.id,
				  episodeId: data.video_id || data.id,
				  isColumn:res.code == 0 ? 0 : 1,
				},
			 });
		})
	},
  },
};
</script>

<style lang="scss" scoped>
$TOP_HEIGHT: 178px;

.top_bar-base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  z-index: 999;
  .top_bar-content {
    background-color: $C1;
    position: relative;
  }
  .logo-bl {
    width: 172px;
    height: 60px;
    margin: 0 auto;
    padding-top: 28px;
    transition: height 0.3s ease, padding 0.3s ease;
    overflow: hidden;
    &.hide {
      height: 0;
      padding: 0;
    }
    .logo-img {
      width: 100%;
      height: auto;
      object-fit: contain;
      vertical-align: bottom;
    }
  }
  .top_bar-bottom-bl {
    height: 90px;
    position: relative;
    .text-logo {
      width: 224px;
      height: 52px;
      position: absolute;
      left: 6%;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      transition: opacity 0.3s ease;
      &.show {
        opacity: 1;
      }
    }
    .company-logo {
      height: 24px;
      position: absolute;
      left: 6%;
      top: 50%;
      transform: translateY(-50%);
      opacity: 1;
      transition: opacity 0.3s ease;
      &.show {
        opacity: 0;
      }
    }
    .tabs-bl {
      padding: 25px 0;
      box-sizing: border-box;
      text-align: center;
    }
  }
  .top_bar-actions-bl {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    .iconfont {
      font-size: 18px;
      color: $C4;
      width: 34px;
      height: 34px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 1px solid $C5;
    }
    .search-icon,
    .close-btn {
      margin-right: 30px;
    }
    .btn {
      vertical-align: top;
      display: inline-block;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .user-icon {
      .user_avatar {
        width: 36px;
        height: 36px;
        object-fit: cover;
        border-radius: 50%;
        display: inline-block;
      }
    }
  }
  .search_res-wrap {
    height: 0;
    opacity: 0;
    transition: all 0.5s ease;
    position: fixed;
    z-index: 999;
    top: #{$TOP_HEIGHT};
    width: 100%;
    left: 0;
    overflow: hidden;
    &.show {
      height: calc(100vh - #{$TOP_HEIGHT});
      opacity: 1;
      background-color: $C1;
    }
    .search-bl {
      width: 100%;
      height: 100%;
      padding-top: 45px;
      box-sizing: border-box;
      .search_input {
        width: 1000px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        border-bottom: 1px solid $C5;
        input {
          display: block;
          flex: 1;
          border: none;
          outline: none;
          font-size: 18px;
          font-family: sans-serif;
          font-weight: 300;
          color: $C3;
        }
        .iconfont {
          font-size: 24px;
          color: #bdbdbd;
          margin-bottom: 5px;
          transition: color 0.3s ease-in;
          &.active {
            color: $C3;
          }
        }
      }
      .search_results-bl {
        .search_results {
          text-align: center;
          &-title {
            text-align: center;
            color: #999;
            height: 50px;
            line-height: 50px;
            font-weight: 500;
          }
        }
      }
      .search_results-bl,
      .search_historys-bl {
        height: calc(100% - 48px);
        overflow-y: auto;
        padding: 30px 20%;
        box-sizing: border-box;
        text-align: center;
        .search-item,
        .history-item {
          line-height: 2;
          font-size: 16px;
          color: $C6;
          cursor: pointer;
          &:hover {
            color: $C7;
          }
        }
      }
      .empty-bl {
        height: calc(100% - 48px);
        padding: 30px 0;
        box-sizing: border-box;
        text-align: center;
        color: $C5;
        font-size: 16px;
      }
    }
  }
}
@media (min-width: 1441px) {
  .top_bar-actions-bl {
    right: 10%;
  }
}

@media (max-width: 1440px) {
  .top_bar-actions-bl {
    right: 120px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.el-tabs {
  display: inline-block;
  margin-right: 45px;
  ::v-deep.el-tabs__item {
    font-size: 16px;
    font-weight: 600;
    color: $C3;
    transition: all 0.3s ease;
    height: 35px;
    padding: 0 24px;
  }
  ::v-deep.el-tabs__header {
    margin: 0;
  }
  ::v-deep.el-tabs__active-bar {
    background-color: $C2;
  }
  ::v-deep.el-tabs__item.is-active {
    font-weight: bolder;
  }
  ::v-deep.el-tabs__item.is-active,
  ::v-deep.el-tabs__item:hover {
    color: $C2;
  }
  ::v-deep.el-tabs__item:nth-child(2):hover::after {
    left: 0;
    transform: translateX(0%);
  }
  ::v-deep.el-tabs__item:last-child:hover::after {
    right: 0;
    left: unset;
    transform: translateX(0%);
  }
  ::v-deep.el-tabs__item:hover::after {
    content: ' ';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 2px;
    background-color: $C2;
    transition: all 0.3s ease;
  }
  ::v-deep.el-tabs__nav-wrap::after {
    content: none;
  }
}
</style>
